import { Sparkle } from 'lucide-react';

// Recipe-book categories the site actually carries. Purely decorative, so the whole ribbon is
// hidden from assistive technology; the list is rendered twice so the scroll loops seamlessly.
const dishes = [
    'پلو و غذای برنجی',
    'خورش و کاری',
    'کباب و گریل',
    'آش و سوپ',
    'کوفته و دلمه',
    'کوکو، کتلت و تخم‌مرغ',
    'پیتزا، ساندویچ و برگر',
    'پاستا و نودل',
    'سالاد',
    'صبحانه',
    'کیک و شیرینی',
    'دسر',
];

const FoodRibbon = () => (
    <div className="food-ribbon" aria-hidden="true">
        <div className="food-ribbon-track">
            {[0, 1].map((copy) => (
                <div className="food-ribbon-group" key={copy}>
                    {dishes.map((dish) => (
                        <span key={dish}>{dish}<Sparkle size={16} /></span>
                    ))}
                </div>
            ))}
        </div>
    </div>
);

export default FoodRibbon;
